export const PINNED_PROMPTS: readonly string[] = [
  'Polish my email',
  'Summarize the attached document for the client',
  'Compare the attached documents side by side',
];

export const ADDITIONAL_PROMPTS: readonly string[] = [
  'Does the attached policy cover this?',
  'Explain this insurance term',
  'Draft a renewal delivery email',
  'Review the attached and flag issues',
  'Extract policy details into a table',
  'Is this carrier admitted in [state]?',
  'Reconcile these two reports',
];

export const SUGGESTED_PROMPTS: readonly string[] = [...PINNED_PROMPTS, ...ADDITIONAL_PROMPTS];
